module.exports = __webpack_public_path__ + "img/blue.3f3375d3.png";